export * from "./mobilepay-start.component";